import { tableEnUSTranslations } from "../components/table/_lang/en-US";
import { draftEnUSTranslations } from "../hooks/_lang/en-US";

export const rayaLucariaEnUS = {
  ...tableEnUSTranslations,
  ...draftEnUSTranslations,
  apply: "Apply",
  cancel: "Cancel",
  clear: "Clear",
  confirm: "Confirm",
  filter: "Filter",
};

export type RayaLucariaTranslationKey = keyof typeof rayaLucariaEnUS;
